import { Notification } from 'element-ui';

export default{
   //全局URL
   getUrl(){
      //1. 域名-https://dev.egolm.com-      2. IP-10.10.0.15:9090-  测试环境   3.localhost:808为访问linux 开发  809端口为访问测试 , 807为本地开发
      //4.https://erp.egolm.com 正式环境   https://test.egolm.com/linkfern-erp-api
      return 'https://dev.linkfern.com/linkfern-erp-api';
      //return 'http://localhost:908/linkfern-erp-api';

   },
   //全局阿里云图片地址域名
   getCdnUrl(){
        return 'http://img.egolm.com/'
   },
		// ajx: ajax对象, func:then函数
		myAjax(ajx,func){
			let sessionUser=JSON.parse(window.sessionStorage.getItem(this.appKey()))
			if(sessionUser){
          //-----------------参数 拦截器----------------------------
          //加入session
          ajx.data["Operator"]=sessionUser.userId;
          ajx.data["OperName"]=sessionUser.userName;

        ajx.data["LangID"]=936;
          var header = {"token":sessionUser.token};
          ajx["headers"] = header;
          //-----------------参数 拦截器----------------------------
          $.ajax(ajx).then(function(d){
            if(func) func(d);
          })
			}else{
				window.sessionStorage.setItem("jumpUrl",decodeURI(window.router._currentRoute.path));
				window.router.go({name:"login"})
			}
		},
		//判断字符串是否为合法日期格式 (yyyy-MM-dd)
		isDateStr(dateStr) {
			let r = new RegExp("^[1-2]\\d{3}-(0?[1-9]||1[0-2])-(0?[1-9]||[1-2][1-9]||3[0-1])$");
			return r.test(dateStr);
		},
		//判断字符串是否为合法时间格式 (hh:mm:ss)
		isTimeStr(timeStr) {
			let Time = /^(?:(?:[0-2][0-3])|(?:[0-1][0-9])):[0-5][0-9]:[0-5][0-9]$/;
			return Time.test(timeStr);
		},
		//判断字符串是否为合法 日期 时间 格式 (yyyy-MM-dd hh:mm:ss)
		isDatetimeStr(datetimeStr) {
				let reDateTime = /^(?:18|19|20)[0-9][0-9]-(?:(?:0[1-9])|(?:1[0-2]))-(?:(?:[0-2][1-9])|(?:[1-3][0-1])) (?:(?:[0-2][0-3])|(?:[0-1][0-9])):[0-5][0-9]:[0-5][0-9]$/;
        return reDateTime.test(datetimeStr);
		},
		//是否为IE或edge
		isIEOrEdge(){
			let ie;
			if (!!window.ActiveXObject || "ActiveXObject" in window) { ie= true;}
					else{    ie= false;}
			let isEdge =  navigator.userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
			if (isEdge||ie){
							return true;
			}else{
				return false;
			}
		},
		//是否手机浏览
		terminalInfo(){
			let  ua = navigator.userAgent;
			let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
			let  isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
			let  isAndroid = ua.match(/(Android)\s+([\d.]+)/);
			return {
				isMobile: (isIphone || isAndroid),
				isIphone:isIphone,
				isAndroid:isAndroid
			}
		},
		//判断 系统标识
		appKey(){
			//卡券系统
			const couponKey="api_manage";
			return couponKey;
		},
    //缓存 登陆时系统信息
    systemInfo(){
      const  systemInfo = this.appKey()+"_systeminfo";
      return systemInfo;
    },
    systemMenuName(){
      const  menuName = this.appKey()+"_menuName";
      return menuName;
    },
    accountInfo(){
      const  accountInfo = this.appKey()+"_accountInfo";
      return accountInfo;
    },

		//检查eGrid body中字段是否提交
		checkFieldCommit(eGridTheadJson,tabId,key){
			if(eGridTheadJson != null){
				let tabIdJson = eGridTheadJson[tabId];
				let tabId = tabIdJson[0];
				return tabId[key];
				}
		},
		//浅拷贝
		extendCopy(p) {
　　　　let c = {};
　　　　for (let i in p) {
　　　　　　c[i] = p[i];
　　　　}
　　　　c.uber = p;
　　　　return c;
　},
		//深拷贝
		deepCopy(p, c) {
　　　　var c = c || {};
　　　　for (var i in p) {
　　　　　　if (typeof p[i] === 'object') {
　　　　　　　　c[i] = (p[i].constructor === Array)? [] : {};
　　　　　　　　this.deepCopy(p[i], c[i]);
　　　　　　} else {
　　　　　　　　c[i] = p[i];
　　　　　　}
　　　　}
　　　　return c;
　},
		//检查对象值是否为空
		checkJsonIsNull(jsonStr){
			if(jsonStr){
				let value = '';
				for(let key in jsonStr){
					value += jsonStr[key];
				}
				if(value == ''){
					return true;
				}else{
					return false;
				}
			}
			return true;
		},
		//截断字符串
		strByLen(title,len) {
			if (title.length > len) {
				return title.substr(0, len) + '...'
			} else {
				return title
			}
		},
		//指定时间距离现在多久
		fromNow (time) {
			const between = Date.now() / 1000 - Number(time)
			if (between < 3600) {
				return pluralize(~~(between / 60), ' 分钟前')
			} else if (between < 86400) {
				return pluralize(~~(between / 3600), ' 小时前')
			} else {
				return pluralize(~~(between / 86400), ' 天前')
			}
		},
		pluralize (time, label) {
			return time + label
		},
		//解析URL各部分
		parseURL(url) {
			let a =  document.createElement('a');
			a.href = url;
			return {
				source: url,
				protocol: a.protocol.replace(':',''),
				host: a.hostname,
				port: a.port,
				query: a.search,
				params: (function(){
					let ret = {},
						seg = a.search.replace(/^\?/,'').split('&'),
						len = seg.length, i = 0, s;
					for (;i<len;i++) {
						if (!seg[i]) { continue; }
						s = seg[i].split('=');
						ret[s[0]] = s[1];
					}
					return ret;
				})(),
				file: (a.pathname.match(/\/([^\/?#]+)$/i) || [,''])[1],
				hash: a.hash.replace('#',''),
				path: a.pathname.replace(/^([^\/])/,'/$1'),
				relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [,''])[1],
				segments: a.pathname.replace(/^\//,'').split('/')
			};
		},
		//显示加载动画
		showLoading: function () {
				// if ($(".spinner-parent")) {
				// 		$(".spinner-parent").remove();
				// }
				// $(document.body).prepend("<div class='spinner-parent' style='position: absolute; z-index: 657; background-color: rgba(255, 255, 255, 0.901961); margin: 0px; top: 160px; right: 0px; bottom: 0px; left: 200px;'><div class='el-loading-spinner' style='position: absolute; display: inline-block; left: 0px;'><svg class='circular' viewBox='25 25 50 50'><circle class='path' cx='50' cy='50' r='20' fill='none'></circle></svg><p class='el-loading-text'>拼命加载中</p></div></div>");
		},
		//移除加载动画
		removeLoading:function(){
			//$(".spinner-parent").remove();
		},
    resizeEChartContainer(id){
      let EChartContainer = document.getElementById(id);
      if (EChartContainer){
        if (window.innerWidth<=1200){
          EChartContainer.style.width = (window.innerWidth-25)+'px';
          EChartContainer.style.height =(window.innerHeight - 145)+'px';
        }
        else{
          EChartContainer.style.width = (window.innerWidth - 235)+'px';
          EChartContainer.style.height =(window.innerHeight - 180)+'px';
        }
      }
      return EChartContainer;
    },
  //获取当前日期的前后几天
  GetDateStr: function(AddDayCount) {
    if(!AddDayCount){
      AddDayCount = 0;
    }
    var dd = new Date();
    dd.setDate(dd.getDate() + parseInt(AddDayCount)); //获取AddDayCount天后的日期
    var y = dd.getFullYear();
    var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1); //获取当前月份的日期，不足10补0
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
    return y + "-" + m + "-" + d;
  },
  //获取当前日期的前后几天（带时分秒）
  GetDateTimeStr:function(AddDayCount) {
    if(!AddDayCount){
      AddDayCount = 0;
    }
    var dd = new Date();
    dd.setDate(dd.getDate() + parseInt(AddDayCount)); //获取AddDayCount天后的日期
    var Y = dd.getFullYear() + '-';
    var M = (dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1) + '-';
    var D = dd.getDate() + ' ';
    var h = dd.getHours() < 10 ? '0' + dd.getHours()+ ':' : dd.getHours()+ ':';
    var m = dd.getMinutes() < 10 ? '0' + dd.getMinutes()+ ':' : dd.getMinutes()+ ':';
    var s = dd.getSeconds() < 10 ? '0' + dd.getSeconds() : dd.getSeconds();
    //console.log(Y+M+D+h+m+s);
    return Y+M+D+h+m+s;
  },
  //获取当前月份（带时分秒）
  GetMonthStr:function(AddMonthCount) {
    if(!AddMonthCount){
      AddMonthCount = 0;
    }
    var dd = new Date();
    //获取AddDayCount加减月份
    dd.setMonth(dd.getMonth()+parseInt(AddMonthCount));
    var Y = dd.getFullYear() + '-';
    var M = (dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1);
    //console.log(Y+M);
    return Y+M;
  },
  //取布尔类型的默认值
  GetBooleanDefault:function(DefaultValue) {
    if(!DefaultValue){
      DefaultValue = 0;
    };
    if (DefaultValue!=1 || DefaultValue!=0){
      DefaultValue = 0;
    };
    return DefaultValue;
  },
  ReplaceAll:function (Str, FindText, RepText) {
    var regExp = new RegExp(FindText,"g");
    return Str.replace(regExp, RepText);
  },
  formatDate:function(date){
    try {
      date = date.format("yyyy-MM-dd");
    } catch (err) {
    }
    return date;
  }  ,
  formatDate1:function(date){
    try {
      date = date.format("yyyy-MM-dd hh:mm:ss");
    } catch (err) {
    }
    return date;
  }  ,
  getHhMmSs:function(str){
    var oDate = new Date(str); //实例一个时间对象；
    var hh = oDate.getHours() < 10 ? '0' + oDate.getHours()+ ':' : oDate.getHours()+ ':';
    var mm = oDate.getMinutes() < 10 ? '0' + oDate.getMinutes()+ ':' : oDate.getMinutes()+ ':';
    var ss = oDate.getSeconds() < 10 ? '0' + oDate.getSeconds() : oDate.getSeconds();
    return hh+mm+ss;
  },
  jsonToQueryParam:function (jsonStr){
      let paramStr = "";
      if(jsonStr){
          for(let key in jsonStr){
            let value = jsonStr[key];
            paramStr += key+"="+value+"&";
          }
      }
      if(paramStr != ''){
        paramStr = paramStr.substring(0,paramStr.length -1);
      }
      return paramStr;
  },
    getRootPath:function(curWwwPath){  // html文件使用
      //var curWwwPath = "http://localhost:808/#/orderDetails";
      //console.log('curWwwPath--'+curWwwPath);
      var pos = curWwwPath.indexOf("#");
      var localhostPath = curWwwPath.substring(0,pos);
      return localhostPath;
  },
    getRealPath:function (){   //VUE文件使用
        //获取当前网址，如： http://localhost:8083/myproj/view/my.jsp
        var curWwwPath=window.document.location.href;
        //获取主机地址之后的目录，如： myproj/view/my.jsp
        var pos = curWwwPath.indexOf("#");
         var localhostPath = curWwwPath.substring(0,pos);
        console.log(localhostPath);
        return localhostPath;
    },
  //制保留2位小数，如：2，会在2后面补上00.即2.00
  toDecimal:function(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return false;
      }
      var f = Math.round(x * 100) / 100;
      var s = f.toString();
      var rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + 2) {
        s += '0';
      }
      return s;
  },
  replaceAll:function(str){
      if(str){
         str = str.replace(/[&\|\\\*^%$#@\-]/g,"").replace(/'/g,"");
      }
      return str;
  }
  ,
  success:function(self,msg, offset){
    self.$notify({
      title: '成功',
      message: msg,
      offset:offset || 80,
      type: 'success'
    });
  },
  warning:function(self,msg, offset){
    self.$notify({
      title: '警告',
      message: msg,
      offset: offset ||80,
      type: 'warning',
      duration: 8000,
    });
  },
  info:function(self,msg, offset){
    self.$notify({
      title: '消息',
      message: msg,
      offset: offset || 80,
      type: 'info',
      duration: 8000,
    });
  },
  error:function(self,msg, offset){
    self.$notify({
      title: '错误',
      message: msg,
      offset: offset || 80,
      type: 'error'
    });
  },
  eleErrorJson:function(errMsg){
      return {
        title: '错误',
        message: errMsg,
        offset:80,
        type: 'error'
      };
  },
  eleInfoJson:function(infoMsg){
    return {
      title: '消息',
      message: infoMsg,
      offset:80,
      type: 'info'
    };
  },
  contains:function (arr, obj) { //判断一个值是否在数组中存在
  var i = arr.length;
  while (i--) {
    if (arr[i] === obj) {
      return true;
    }
  }
  return false;
},

//校验手机号
  checkMobile:function(mobile){
      var re= /^1[3|4|5|7|8]\d{9}$/;
      if(re.test(mobile)){
        return true;
      }else{
        return false;
      }
  },
  //校验邮箱
  checkEmail:function(email){
    var re= /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;
      if(re.test(email)){
        return true;
      }else{
        return false;
      }
  },
  //判断object/json 是否为空
  isEmptyObject(obj) {
    for (var key in obj) {
      return false;
    }
    return true;
  },
  //检查用户权限
  checkUserPower(userId,powerId){
    let self = this;
    var isPower = false;
    this.myAjax({
      url: self.getUrl() + "/StdQuery/StdQuery",
      dataType: "json",
      cache : false,
      async: false,
      data: {
        queryName: 'GetUserPower',
        UserID: userId,
        PowerID: powerId
      },
      beforeSend(){
      },
      success(d){
        if(d.isValid){
          let dataList = d.data.dataList;
          if (dataList && dataList.length > 0)
            isPower = true
          else
            isPower = false;
        }else{
          var errors = d.errors;
          if(errors.hasOwnProperty('errorMsg')){
            var errorMsg=errors['errorMsg'];
            Notification(self.eleErrorJson(errorMsg));
          }else{
            Notification(self.eleErrorJson('查询参数请求异常'));
          };
          isPower = false;
        };
      },
      error(){
        Notification(self.eleErrorJson('查询结果请求出错'));
        isPower = false;
      }
    });
    if (!isPower)
      Notification(self.eleErrorJson('您没有访问当前功能模块的权限！'));
    return isPower;
  },
  fullScreen(){
    var el = document.documentElement;
    var rfs = el.requestFullScreen || el.webkitRequestFullScreen ||
      el.mozRequestFullScreen || el.msRequestFullScreen;
    if(typeof rfs != "undefined" && rfs) {
      rfs.call(el);
    } else if(typeof window.ActiveXObject != "undefined") {
      //for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
      var wscript = new ActiveXObject("WScript.Shell");
      if(wscript != null) {
        wscript.SendKeys("{F11}");
      }
    }
  },
  exitFullScreen() {
    var el = document;
    var cfs = el.cancelFullScreen || el.webkitCancelFullScreen ||
      el.mozCancelFullScreen || el.exitFullScreen;
    if(typeof cfs != "undefined" && cfs) {
      cfs.call(el);
    } else if(typeof window.ActiveXObject != "undefined") {
      //for IE，这里和fullScreen相同，模拟按下F11键退出全屏
      var wscript = new ActiveXObject("WScript.Shell");
      if(wscript != null) {
        wscript.SendKeys("{F11}");
      }
    }
  },
  /**************************************时间格式化处理************************************/
  dateFtt(fmt,date){
    var s = date;
    if (typeof s == 'object')
      s = date.toDateString();
    s = s.replace(/-/g,"/");
    var newdate = new Date(s);
    var o = {
      "M+" : newdate.getMonth()+1,                 //月份
      "d+" : newdate.getDate(),                    //日
      "h+" : newdate.getHours(),                   //小时
      "m+" : newdate.getMinutes(),                 //分
      "s+" : newdate.getSeconds(),                 //秒
      "q+" : Math.floor((newdate.getMonth()+3)/3), //季度
      "S"  : newdate.getMilliseconds()             //毫秒
    };
    if(/(y+)/.test(fmt))
      fmt=fmt.replace(RegExp.$1, (newdate.getFullYear()+"").substr(4 - RegExp.$1.length));
    for(var k in o)
      if(new RegExp("("+ k +")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    return fmt;
  },
  /**************************************根据省份取地图坐标************************************/
  convertData(data){
    var res = [];
    var geoCoordMap = {
      '北京': [116.46, 39.92],
      '上海': [121.29, 31.14],
      '天津': [117.2, 39.13],
      '重庆': [106.32, 29.32],
      '黑龙江': [126.41, 45.45],
      '吉林': [125.19, 43.52],
      '辽宁': [123.24, 41.50],
      '内蒙古': [111.48, 40.49],
      '河北': [114.28, 38.02],
      '山西': [112.34, 37.52],
      '山东': [117, 36.38],
      '河南': [113.42, 34.48],
      '陕西': [108.54, 34.16],
      '甘肃': [103.49, 36.03],
      '宁夏': [106.16, 38.20],
      '青海': [101.45, 36.38],
      '新疆': [87.36, 43.48],
      '安徽': [117.18, 31.51],
      '江苏': [118.50, 32.02],
      '浙江': [120.09, 30.14],
      '湖南': [113, 28.11],
      '江西': [115.52, 28.41],
      '湖北': [114.21, 30.37],
      '四川': [104.05, 30.39],
      '贵州': [106.42, 26.35],
      '福建': [119.18, 26.05],
      '广东': [113.15, 23.08],
      '海南': [110.20, 20.02],
      '广西': [108.20, 22.48],
      '云南': [102.41, 25],
      '西藏': [91.10, 29.40],
      '香港': [114.10, 22.18],
    };
    for (var i = 0; i < data.length; i++) {
      var geoCoord = geoCoordMap[data[i].name];
      if (geoCoord) {
        res.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value),
          value2: data[i].value,
        });
      }
    };
    return res;
  },
  setCookie: function(c_name,value,expiremMinutes){
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + expiremMinutes * 60 * 1000);
    document.cookie= c_name + "=" + escape(value)+((expiremMinutes==null) ? "" : ";expires="+exdate.toGMTString());
  },

// 读取cookie
  getCookie: function(c_name){
    if (document.cookie.length>0)
    {
      var c_start=document.cookie.indexOf(c_name + "=");
      if (c_start!=-1)
      {
        c_start=c_start + c_name.length+1;
        var c_end=document.cookie.indexOf(";",c_start);
        if (c_end==-1)
          c_end = document.cookie.length
        return unescape(document.cookie.substring(c_start, c_end))
      }
    }
    return ""
  },

// 删除cookie
  delCookie: function(c_name){
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(c_name);
    if(cval!=null){
      document.cookie = c_name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  },
}




// WEBPACK FOOTER //
// ./src/util.js